import { compose } from 'redux'
import { connect } from 'react-redux'
import { setAppBarValues } from '../../App/actions'
import { withNotifications } from '../../modules/notification';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles'

const mapStateToProps = ({  }) => {


    return {};
};


export default compose(
    // withNotifications,
    connect(mapStateToProps, { setAppBarValues }),
    withNotifications,
    withStyles(styles)


);


// WEBPACK FOOTER //
// ./src/components/ContainerCrud/ContainerCrud.enhancer.js